<div class="avatar" [ngStyle]="{height: avatarSizePixels, width: avatarSizePixels}">
  <div class="avatar-initials" [ngStyle]="{'font-size': fontSizePixels}">
    {{avatarInitials}}
  </div>
</div>
